<template>
  <a-button type="primary" class="btn" @click="$emit('click')">
    <slot>{{ btnText }}</slot>
  </a-button>
</template>

<script>
export default {
  name: 'GradientBtn',
  props: {
    btnText: {
      type: String,
      default: 'btn'
    }
  }
}
</script>

<style scoped lang="less">
.btn {
  height: 45px;
  padding: 0 80px;
  color: white;
  background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
  border: none;
  border-radius: 21px;
}
</style>